export enum BookVisitStatus {
  Unknown = 0,
  Succeeded = 1,
  SlotNotAvailable = 2,
  UsernameAlreadyInUse = 3
}
